import { sameNodePosition } from "../../components/markdown/utils";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const preBlockVariants = cva(["my-2 w-full break-all rounded-2xl border", "border-border"], {
  variants: {
    variant: {
      surface: "bg-muted-background"
    }
  }
});
/**
 * Renders `<pre>` elements inside Markdown output as the rounded container
 * around fenced code blocks, falling back to the node's meta string when the
 * code content is empty.
 * @summary Pre-element container for Markdown code blocks.
 */
export const PreBlock = memo(({
  children,
  variant = "surface"
}) => {
  const validChildrenContent = Array.isArray(children) && children[0] ? children[0].props.children[0] : null;
  let fallbackData = null;
  if (!validChildrenContent) {
    var _children$0$props;
    fallbackData = Array.isArray(children) && children[0] ? (_children$0$props = children[0].props) === null || _children$0$props === void 0 || (_children$0$props = _children$0$props.node) === null || _children$0$props === void 0 || (_children$0$props = _children$0$props.data) === null || _children$0$props === void 0 ? void 0 : _children$0$props.meta : null;
  }
  return /*#__PURE__*/React.createElement("pre", {
    className: preBlockVariants({
      variant
    })
  }, validChildrenContent ? children : fallbackData || children);
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.variant === next.variant);
PreBlock.displayName = "PreBlock";
//# sourceMappingURL=PreBlock.js.map